import { Container, Input, Button, Text, Row, Spacer, Image, Loading, Badge, Modal } from '@nextui-org/react'
import React from 'react'
import { auth } from '../config/firebase'
import { signInWithEmailAndPassword, sendPasswordResetEmail, OAuthProvider, signInWithPopup } from 'firebase/auth'
import { useNavigate } from "react-router-dom";
import {toast} from 'react-toastify'
import { collection, setDoc, doc, getDocs, query, updateDoc, deleteDoc } from 'firebase/firestore';
import { firestore } from '../config/firebase';
import useApi from '../Hooks/useApi';

const Login = () => {
  const [email, setEmail] = React.useState('')
  const [emailForgot, setEmailForgot] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [error, setError] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [visible, setVisible] = React.useState(false)
  const [userDocList, setUserDocList] = React.useState([])
  const [visibleModalSender, setVisibleModalSender] = React.useState(false)
  const [senderName, setSenderName] = React.useState('')
  const [senderCode, setSenderCode] = React.useState('')
  const {code} = useApi();
  const navigate = useNavigate();
  
  const handleSubmit = async (e) => {
    setLoading(true)
    if (email === '' || password === '') {
      setLoading(false)
      return setError('Veuillez remplir tous les champs.')
    }
    try {
      await signInWithEmailAndPassword(auth, email, password).then((user) => {
        toast.success("Connexion éffectué", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          theme: "colored",
        })
        navigate('/dashboard')
      }).catch((error) => {
        setError(error.code + ' : ' + error.message)
      })
    } catch (error) {
      return setError(error.message)
    }
    setError('')
    setLoading(false)
  }

  const createAccountByMicrosoft = async (uid, email, firstname, lastname, senderName) => {
    try {
            const collectionRef = collection(firestore, "users");
            const docRef = setDoc(doc(collectionRef, uid), {
                email: email,
                firstname: firstname,
                lastname: lastname,
                role: 'user',
                senderName: senderName
            });
        }
        catch (error) {
          console.error("Error adding document: ", error);
        }
  }

  React.useEffect(() => {
    const getDocsUsers = async () => {
      try {
        const q = query(collection(firestore, "users"));
        const querySnapshot = await getDocs(q);
        let data = []
        querySnapshot.forEach((doc) => {
          data.push({id: doc.id, ...doc.data()})
        });
        setUserDocList(data)
      }
      catch (error) {
        setError(error.message)
      }
    }
    getDocsUsers();
  }, [])  

  const openModalSender = () => {
    setVisibleModalSender(true)
  }

  //Edit sender name in firestore after microsoft login
  const handleEditSenderName = async () => {
    try {
        const collectionRef = collection(firestore, "users");
        const docRef = updateDoc(doc(collectionRef, auth.currentUser.uid), {
            senderName: senderName
        });
        setVisibleModalSender(false)
        navigate('/dashboard')
        toast.success("Connexion éffectué", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          theme: "colored",
        })
    }
    catch (error) {
      console.error("Error adding document: ", error);
    }
  }

  const handleConnectMicrosoft = async () => {
    setLoading(true)
    const provider = new OAuthProvider('microsoft.com');
    provider.setCustomParameters({
      prompt: "consent",
      tenant: "5c931336-fdfb-45a6-bf13-6bd74d5f78c6",
    })
    signInWithPopup(auth, provider).then(async (result) => {
      const credential = OAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      const user = result.user; 
      if (!userDocList.some(userDoc => userDoc.id === user.uid)) {
        createAccountByMicrosoft(user.uid, user.email, user.displayName.split(' ')[0], user.displayName.split(' ')[1], "")
        openModalSender()
      } else {
        navigate('/dashboard')
        toast.success("Connexion éffectué", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          theme: "colored",
        })
      }
    }).catch((error) => {
      setError(error.code + ' : ' + error.message)
      if (error.code === 'auth/popup-closed-by-user') {
        setError('Popup fermé par l\'utilisateur.')
      }
    });
    setLoading(false)
  }

  const closeHandler = () => {
    setVisible(false)
  }

  const closeHandlerSender = () => {
    setVisibleModalSender(false)
    //Delete microsoft account 
    auth.currentUser.delete().then(() => {
      // User deleted.
    }).catch((error) => {
      console.error(error.code + ' : ' + error.message)
    }
    );
    //Delete microsoft account in firestore
    const collectionRef = collection(firestore, "users");
    const docRef = deleteDoc(doc(collectionRef, auth.currentUser.uid));
  }

  const handleForgotPassword = async () => {
    await sendPasswordResetEmail(auth, emailForgot).then(() => {
      toast.success("Un email de réinitialisation de mot de passe vous a été envoyé", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        theme: "colored",
      })
      closeHandler()
    }).catch((error) => {
      setError(error.code + ' : ' + error.message)
      console.error(error.code + ' : ' + error.message)
    })
  }

  const navigateRegister = () => {
    navigate('/register')
  }

  const reduceError = (error) => {
    if (error.length > 100) {
      return error.substring(0, 100) + '...'
    } else {
      return error
    }
  }


  return (
    //Formulaire de login NextUI centré au milieu de la page
    <>
    <Container >
      <Row justify="center" css={{marginTop: "$5"}}>
        <Image src="https://i.ibb.co/6Bw3kNc/Logo-ITS.png" width="200px" height="200px" />
      </Row>
      <Spacer y={1} />
      <Row justify="center">
        <Text
          h2
          size={30}
          weight="bold"
        >
          Bienvenue sur IT SMS
        </Text>
      </Row>
      <Spacer y={1} />
      {error ?
      <>
        <Badge color="error">{reduceError(error)}</Badge>
        <Spacer y={1} />
      </>
      : null}
      <Spacer y={1} />
      <Row justify="center">
        <Input
          width="300px"
          size='lg'
          type="text"
          color="primary"
          bordered 
          labelPlaceholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)} 
         />

      </Row>
      <Spacer y={2} />
      <Row justify="center">
        <Input.Password
          width="300px"
          size='lg'
          type="password"
          color="primary"
          bordered 
          labelPlaceholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Row>
      <Spacer y={1} />
      <Row justify="center">
        <Button size={'sm'} onPress={() => setVisible(true)}>Mot de passe oublié ?</Button>
      </Row>      
      <Spacer y={1} />
      <Row justify='center'>
        {
          loading ? (
            <Button disabled auto bordered color="success" css={{ px: "$13" }}>
              <Loading type="points" color="currentColor" size="sm" />
            </Button>
          ) : (
            <Button
            size='lg'
            type='submit'
            color="primary"
            shadow
            onClick={(e) => handleSubmit(e)}
          >
            Se connecter
          </Button>
          )
        }
      </Row>
      <Spacer y={1} />
        <Row justify='center'>
          <Text weight={"bold"}>Ou</Text>
        </Row>
      <Spacer y={1} />
      <Row justify='center'>
        <Button
          size='lg'
          type='submit'
          color="gradient"
          shadow
          onClick={(e) => handleConnectMicrosoft(e)}
        >
          <Image src='https://learn.microsoft.com/fr-fr/azure/active-directory/develop/media/howto-add-branding-in-azure-ad-apps/ms-symbollockup_mssymbol_19.png' />
          <Spacer x={1} />
          Connexion avec Microsoft
        </Button>
      </Row>
        <Spacer x={1} />
      <Row justify='center'>
        <Button shadow onPress={() => navigateRegister()} size={'lg'} color={'secondary'} >
          S'inscrire
        </Button>
      </Row>
    </Container>
    <Modal
      closeButton
      blur
      aria-labelledby="Deconnexion"
      open={visible}
      onClose={closeHandler}
      > 
      <Modal.Header>
      <Text id="modal-title" size={18}>
          Reinitialisation de mot de passe
      </Text>
      </Modal.Header>
      <Modal.Body>
      <Spacer  />
      <Input
          size='lg'
          type="text"
          color="primary"
          bordered
          labelPlaceholder="Email"
          value={emailForgot}
          onChange={(e) => setEmailForgot(e.target.value)}
        />
      <Button auto color="success" onPress={() => handleForgotPassword()}>
          Envoyer un email de réinitialisation
      </Button>
      </Modal.Body>
    </Modal>
    <Modal
      closeButton
      blur
      aria-labelledby="popup suppression contact"
      open={visibleModalSender}
      onClose={closeHandlerSender}
      > 
      <Modal.Header>
      <Text id="modal-title" size={18}>
          Entrer un nom d'expediteur et code confidentiel
      </Text>
      </Modal.Header>
      <Modal.Body>
      <Spacer y={1} />
      <Input
          size='lg'
          type="text"
          color="primary"
          bordered
          labelPlaceholder="Nom d'expediteur"
          value={senderName}
          onChange={(e) => {setSenderName(e.target.value); }}
      />
      <Spacer  y={0.1}/>
      <Input
          size='lg'
          type="text"
          color="primary"
          bordered
          labelPlaceholder="Code confidentiel"
          value={senderCode}
          onChange={(e) => {setSenderCode(e.target.value); }}
      />
      {
        senderCode !== code.code ?
        <Button disabled auto color="success" onPress={() => {handleEditSenderName()}}>
          Confirmer
        </Button>
        :
        <Button auto color="success" onPress={() => {handleEditSenderName()}}>
          Confirmer
        </Button>
      }
      <Button auto color="default" onPress={closeHandlerSender}>
          Annuler
      </Button>
      </Modal.Body>
      <Modal.Footer justify='center'>
        { senderCode !== code.code ?
          <Badge color="error">Code confidentiel incorrect</Badge>
          : 
          null
        }
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default Login